export enum newEmployeeForm {
	newHireCheckbox = 'customNewHireCheckbox',
	payrollCheckbox = 'bamboohrPayrollCheckbox',
	employeeAccess = 'employee_access_field',
	payrollProviderSelectField = 'payrollProviderSelectField',
}
